import React, { memo } from 'react'
import { makeStyles, createStyles } from '@mui/styles'
import { Theme, Typography } from '@mui/material'

import { RATE_AFFIX } from '../../typings'
import { ISpecialInterestRate } from '../special-interest-rate/typings'
import { IBankRatesProps } from './typings'

const useStyles = makeStyles<Theme, ISpecialInterestRate>((theme: Theme) =>
  createStyles({
    rateTextContent: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: 0,
      height: '100%',
      margin: 10,
      minWidth: 150,
      [theme.breakpoints.down('md')]: {
        order: ({ isSpecial }) => (isSpecial ? '-1' : ''),
        width: 'calc(100% - 10px);',
        minWidth: 'calc(100% - 2px);',
      },
    },
    rateTextCls: {
      fontSize: 20,
      fontWeight: 'bold',
      lineHeight: 1.1,
    },
    descriptionTextCls: {
      fontSize: 12,
      fontWeight: 400,
      color: theme.palette.grey[900],
      WebkitFontSmoothing: 'antialiased',
    },
    interestRateCls: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'end',
    },
    microTextCls: {
      fontSize: '9px !important',
      color: theme.palette.grey[500],
      marginLeft: 5,
    },
  }),
)

const NormalInterestRate = ({
  rate,
  descriptionText,
  decorator,
  microText,
  specialInterestRate,
}: IBankRatesProps) => {
  const { descriptionTextCls, interestRateCls, microTextCls, rateTextCls } =
    useStyles(specialInterestRate || { isSpecial: false })
  const rateText =
    decorator.affix === RATE_AFFIX.PREFIX
      ? `${decorator.value}${rate}`
      : `${rate}${decorator.value}`

  return (
    <div>
      {!microText ? (
        <Typography className={rateTextCls}>{rateText}</Typography>
      ) : (
        <span className={interestRateCls}>
          <Typography className={rateTextCls}>{rateText}</Typography>
          <Typography className={microTextCls}>
            bis {microText?.value}%*
          </Typography>
        </span>
      )}
      <Typography className={descriptionTextCls}>{descriptionText}</Typography>
    </div>
  )
}

export default memo(NormalInterestRate)
